import { axiosCustom } from 'common/common.function';
import {
  PartnerAuthCheckOutput,
  PartnerSchedulerListInput,
  PartnerSchedulerListOutput,
} from 'components/form/interfaces/partner-admin.interface';

const getGmpToken = () => {
  return JSON.parse(sessionStorage.getItem('wakeupInfo') || '{}').gmpToken;
};

/**
 * @alias 11번가 파트너 권한 확인
 * @description 프론트엔드에서 '멤버 조회' 탭을 노출할지 여부를 판단하기 위해 사용
 * @returns - 200 { success: true, isPartner: true }
 * @returns - 401 권한 없음
 */
export async function partnerAuthCheck(): Promise<PartnerAuthCheckOutput> {
  const gmptoken = getGmpToken();
  return await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/partner/auth-check`, {
    headers: {
      gmptoken,
    },
  });
}

/**
 * @alias 11번가 스케줄러 유저 리스트 조회
 * @description 11번가 스케줄러를 연동 중인 멤버 목록을 조회
 */
export async function partnerSchedulerList(params: PartnerSchedulerListInput): Promise<PartnerSchedulerListOutput> {
  const gmptoken = getGmpToken();
  return await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/partner/scheduler/list`, {
    headers: {
      gmptoken,
    },
    params,
  });
}

/**
 * @alias 스케줄러 해지
 * @description 특정 유저의 스케줄러를 해지(비활성화)
 */
export async function partnerSchedulerDeactivate(userId: number): Promise<{ success: boolean; message?: string }> {
  const gmptoken = getGmpToken();
  return await axiosCustom.post(
    `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/partner/scheduler/deactivate/${userId}`,
    {},
    {
      headers: {
        gmptoken,
      },
    },
  );
}

/**
 * @alias 스케줄러 재등록(활성화)
 * @description 특정 유저의 스케줄러를 다시 활성화
 */
export async function partnerSchedulerActivate(userId: number): Promise<{ success: boolean; message?: string }> {
  const gmptoken = getGmpToken();
  return await axiosCustom.post(
    `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/partner/scheduler/activate/${userId}`,
    {},
    {
      headers: {
        gmptoken,
      },
    },
  );
}
